export default __webpack_public_path__ + "static/media/integrations-conventus.f0e7c332.png";